import {
  queryOptions,
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';
import landscapeServiceV3 from '../services/landspace.service-v3';
import { SortBy } from '../dto/request/all-landscapes.dto';
import { SortDirection } from '../../../../utils/types/types';

export const landscapeQueriesOptions = {
  all: queryOptions({
    queryKey: ['landscape'],
  }),
  getLandscapes: ({
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: SortBy;
    sortDirection?: SortDirection;
  }) =>
    queryOptions({
      queryKey: [...landscapeQueriesOptions.all.queryKey, 'landscapes'],
      queryFn: async () =>
        await landscapeServiceV3.fetchLandscapes(
          page,
          pageSize,
          sortBy,
          sortDirection
        ),
    }),
  getLandscapeById: (initiativeId: string) =>
    queryOptions({
      queryKey: [...landscapeQueriesOptions.all.queryKey, initiativeId],
      queryFn: async () => landscapeServiceV3.fetchLandscapeById(initiativeId),
    }),
};

export const useInfiniteGetLandscapes = ({
  pageSize = 10,
  sortBy = 'name',
  sortDirection = 'asc',
}: {
  pageSize?: number;
  sortBy?: SortBy;
  sortDirection?: SortDirection;
}) => {
  return useInfiniteQuery({
    queryKey: ['landscape', 'landscapes', sortBy, sortDirection],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await landscapeServiceV3.fetchLandscapes(
        pageParam,
        pageSize,
        sortBy,
        sortDirection
      );
      return {
        ...response,
        nextPage: pageParam + 1,
      };
    },
    getNextPageParam: (lastPage) =>
      lastPage.hasMore ? lastPage.nextPage : undefined,
    initialPageParam: 1,
  });
};

export const useGetLandscapeById = (initiativeId: string) => {
  return useQuery({
    ...landscapeQueriesOptions.getLandscapeById(initiativeId),
    enabled: !!initiativeId,
  });
};

export const useGetLandscapes = () => {
  return useQuery({
    queryKey: ['landscapes', 'id-name'],
    queryFn: () => landscapeServiceV3.getLandscapes(),
  });
};
